<ng-container *ngIf="(showWorkingTimeModal$ | async) || true">
  <app-modal
    *ngIf="isShowModal"
    (closeModal)="onClose()"
    [isHideHead]="true"
  >
    <div class="schedule">
      <div class="schedule__title" i18n="@@RestaurantOpeningHoursTitle">Restaurant opening hours</div>
      <div class="schedule__subtitle">{{address$ | async}}</div>
      <div class="schedule__list" *ngFor="let dayHours of schedule$ | async">
        <div>{{dayNames[dayHours.dayKey]}}</div>
        <div>
          <div *ngFor="let interval of dayHours.intervals">
          {{interval.open}}-{{interval.close}}
          </div>
        </div>
      </div>
    </div>

    <ng-container footer>
      <button type="button" class="button button--th-main _rounded" (click)="onClose()">
        <span class="button__text" i18n="@@CloseButton">Close</span>
      </button>
    </ng-container>
  </app-modal>
</ng-container>
